import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

// 右键菜单
import contextmenu from 'vue3-contextmenu'

// 引入路由管理
import { router } from './router'

// 引入 cookie 管理
import cookie from "js-cookie"

// Http
import axios from 'axios'

// 内部函数
import Common from '../public/js/common'
// import { Config } from '../public/config/config'

// 引入 Toast
import Toast from './components/Toast.vue'
import { createVNode, render } from 'vue'

const ToastPlugin = {
  install(app) {
    const container = document.createElement('div')
    document.body.appendChild(container)
    
    // 使用 h 或 createVNode 渲染组件
    const vm = createVNode(Toast)
    
    // 挂载
    render(vm, container)
    
    // 定义全局方法
    app.config.globalProperties.$Toast = (message, type = 'info', duration = 3000) => {
      // 访问组件实例
      const componentInstance = vm.component.proxy
      if (componentInstance) {
        componentInstance.Show(message, type, duration)
        // 返回一个包含 hide 方法的对象，以便外部手动关闭
        return {
          hide: () => componentInstance.hide()
        }
      }
      return { hide: () => {} } // 降级返回
    }
  }
}

app.use(contextmenu)
app.use(router)
app.use(ToastPlugin)

app.config.globalProperties.$cookie = cookie
app.config.globalProperties.axios = axios
axios.defaults.withCredentials = true

// 请求拦截器：在请求头中注入 Token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：处理 401 等错误
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Token 过期或无效，跳转到登录页
      localStorage.removeItem('token')
      router.push('/Login')
    }
    return Promise.reject(error)
  }
)

app.config.globalProperties.$Common = Common
// app.config.globalProperties.$Config = Config

app.mount('#app')